import { allVesselMetricNames } from '@shared_types/metrics/vessel_metrics'

export const mainKeys = (allVesselMetricNames as string[]).concat(['position', 'totalDistance', 'avgSpeed', 'maxSpeed'])
